import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "fileInput", "preview", "previewContent", "error", "importButton"]
  static values = { url: String }

  connect() {
    console.log("ImportIntentsController connected")
    this.fileData = null
  }

  openModal() {
    console.log("Opening modal")
    this.modalTarget.classList.remove("hidden")
    this.resetForm()
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    this.resetForm()
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    
    if (!file) {
      this.resetForm()
      return
    }

    if (file.type !== "application/json") {
      this.showError("Please select a valid JSON file")
      return
    }

    const reader = new FileReader()
    
    reader.onload = (e) => {
      try {
        const json = JSON.parse(e.target.result)
        
        // Validate the JSON structure
        if (!Array.isArray(json)) {
          this.showError("Invalid format: Expected an array of intents")
          return
        }

        // Validate each intent
        const isValid = json.every(intent => 
          intent.intent_type && 
          intent.expectation &&
          ['cart_add', 'cart_modify', 'cart_remove', 'cart_clear', 'message', 'inquiry'].includes(intent.intent_type)
        )

        if (!isValid) {
          this.showError("Invalid intent format. Each intent must have intent_type and expectation fields.")
          return
        }

        this.fileData = e.target.result
        this.showPreview(json)
        this.importButtonTarget.disabled = false
        this.hideError()
      } catch (err) {
        this.showError("Invalid JSON file: " + err.message)
      }
    }

    reader.onerror = () => {
      this.showError("Error reading file")
    }

    reader.readAsText(file)
  }

  showPreview(json) {
    this.previewTarget.classList.remove("hidden")
    this.previewContentTarget.textContent = JSON.stringify(json, null, 2)
  }

  showError(message) {
    this.errorTarget.classList.remove("hidden")
    this.errorTarget.querySelector("p").textContent = message
    this.importButtonTarget.disabled = true
    this.previewTarget.classList.add("hidden")
  }

  hideError() {
    this.errorTarget.classList.add("hidden")
  }

  resetForm() {
    this.fileInputTarget.value = ""
    this.fileData = null
    this.importButtonTarget.disabled = true
    this.previewTarget.classList.add("hidden")
    this.hideError()
  }

  async import() {
    if (!this.fileData) return

    this.importButtonTarget.disabled = true
    this.importButtonTarget.textContent = "Importing..."

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ intents_data: this.fileData })
      })

      if (response.ok) {
        // Reload the page to show the new intents
        window.location.reload()
      } else {
        const data = await response.json()
        this.showError(data.error || "Import failed")
        this.importButtonTarget.disabled = false
        this.importButtonTarget.textContent = "Import"
      }
    } catch (err) {
      this.showError("Network error: " + err.message)
      this.importButtonTarget.disabled = false
      this.importButtonTarget.textContent = "Import"
    }
  }

}